'use strict';

exports.__esModule = true;
exports.default = undefined;
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _Iovation = require('./Iovation.react');
var _Iovation2 = _interopRequireDefault(_Iovation);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var IoBlackBox = function (_Component) {
  (0, _inherits3.default)(IoBlackBox, _Component);
  function IoBlackBox() {
    (0, _classCallCheck3.default)(this, IoBlackBox);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }
  IoBlackBox.prototype.onChange = function onChange(value) {
    var _props = this.props,
      name = _props.name,
      onChange = _props.onChange;
    onChange({
      name: name,
      value: value
    });
  };
  IoBlackBox.prototype.render = function render() {
    var _this2 = this;
    var value = this.props.value;
    return _react2.default.createElement(_Iovation2.default, {
      value: value,
      onChange: function onChange(val) {
        return _this2.onChange(val);
      }
    });
  };
  return IoBlackBox;
}(_react.PureComponent);
IoBlackBox.propTypes = {
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};
exports.default = IoBlackBox;
module.exports = exports['default'];